<template>
  <div
    v-if="menuItems && menuItems.length"
    class="help-menu relative"
  >
    <div
      v-if="!alwaysOpenOnMobile"
      class="flex items-center justify-between py-2 px-3 cursor-pointer font-bold bg-EXPONDO-grey-5 lg:hidden"
      @click="onToggleMenuOnMobile"
    >
      <span>{{ activeItem && activeItem.menuItemName }}</span>
      <span
        class="iconify svg--carrot-down text-xl transition-transform"
        :class="{'transform-gpu rotate-180': isMobileMenuOpen}"
      />
    </div>

    <div
      class="mt-2 lg:block grid transition-[grid-template-rows] duration-300 ease-in-out"
      :class="isMobileMenuOpen || alwaysOpenOnMobile ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'"
    >
      <div class="overflow-hidden">
        <HelpMenuItem
          v-for="(item, i) in menuItems"
          :key="item.menuItemSlug"
          :current-item-index="i"
          :total-items-count="menuItems.length"
          :item-slug="item.menuItemSlug"
          :item-name="item.menuItemName"
          :is-active="isCurrentRoute(item.menuItemSlug)"
          :is-mobile-menu-open="isMobileMenuOpen"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import type { HelpMenuItemData } from '~~/types/cms/HelpMenuItemData';
import HelpMenuItem from '~/cms/help/HelpMenuItem.vue';

export default defineComponent({
  name: 'HelpMenu',
  components: {
    HelpMenuItem,
  },
  props: {
    menuItems: {
      type: Array as PropType<Array<HelpMenuItemData>>,
      required: true,
    },
    alwaysOpenOnMobile: {
      type: Boolean,
      default: false,
    },
  },
  setup (props) {

    const { isCurrentRoute } = useRouteExtended();
    const isMobileMenuOpen = ref(props.alwaysOpenOnMobile);

    const onToggleMenuOnMobile = () => {

      if (!props.alwaysOpenOnMobile) {

        isMobileMenuOpen.value = !isMobileMenuOpen.value;
      
      }
    
    };

    const activeItem = computed<HelpMenuItemData | undefined>(() =>
      props.menuItems.find(item => isCurrentRoute(item.menuItemSlug)),
    );

    return {
      isMobileMenuOpen,
      onToggleMenuOnMobile,
      activeItem,
      isCurrentRoute,
    };
  
  },
});
</script>
